export const AUTH_COOKIE_EXP_TIME = 60 * 5 * 1000; //1000ms * 60s * 5min
export const API_VERSION = "v1";
